import { GlobeIcon, PinTopIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
import Image from "src/components/Image";
import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from "src/components/ui/card";
import getLogsFromAlcoholData from "src/lib/getLogsFromAlcoholData";
import { Session } from "src/pages/Sessions";
import SessionLogCounter from "./SessionLogCounter";

export default function SessionCard({ session }: { session: Session }) {
  const logs = getLogsFromAlcoholData(session.alcoholData);

  const getDate = () => {
    const date = new Date(logs[0].data.date);

    return date.toLocaleDateString("cs");
  };

  const getLastImage = () => {
    const images = logs.filter((drink) => drink.data.photoData);

    return images[images.length - 1]?.data.photoData;
  };

  return (
    <div style={{ position: "relative" }}>
      <Link to={"/session/" + session._id} key={session._id}>
        <Card>
          <CardContent className="p-4 flex justify-between gap-2">
            <div>
              <CardTitle>
                {session.name}{" "}
                {session.public && (
                  <GlobeIcon className="text-muted-foreground inline-block" />
                )}
              </CardTitle>
              <CardDescription>{getDate()}</CardDescription>
              <div className="flex gap-1 items-center text-muted-foreground">
                <span style={{ color: "#efb541" }}>
                  <PinTopIcon />
                </span>
                {session.sessionMaxPermille} ‰
              </div>
              {getLastImage() && (
                <SessionLogCounter
                  alcoholData={session.alcoholData}
                  className="pt-2 opacity-50"
                />
              )}
            </div>
            <div>
              {getLastImage() && (
                <Image
                  src={getLastImage()}
                  style={{
                    width: "6rem",
                    height: "6rem",
                    objectFit: "cover",
                    borderRadius: "0.5rem",
                  }}
                  alt=""
                />
              )}
              {!getLastImage() && (
                <SessionLogCounter
                  alcoholData={session.alcoholData}
                  className="opacity-50"
                  flexClassName="justify-end items-end gap-2"
                />
              )}
            </div>
          </CardContent>
        </Card>
      </Link>
    </div>
  );
}
